import { React, Spinner } from 'mondrian-react'
import './style.scss'
import FontSizeModal from './FontSizeModal'
import { scrollToElement, scrollToTop } from 'utils/scroll'
import { reportGA4 } from 'utils/pushDataLayer'

const AccessibilityBar = () => {
  const [contrastEnabled, setContrastEnabled] = React.useState(false)
  const [isOpenModal, setIsOpenModal] = React.useState(false)
  const [loadingHandTalk, setLoadingHandTalk] = React.useState(false);

  const DOMHeader = React.useRef(null)

  React.useEffect(() => {
    let storedContrast;
    if(localStorage){
      storedContrast = localStorage.getItem('mcm_high-contrast')
    }
    window.addEventListener('keydown', handleKeyDown);

    if (storedContrast) {
      toggleContrast()
    }

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const toggleContrast = () => {
    document.querySelector('html').classList.toggle('mcm-HighContrast')

    if (!contrastEnabled) {
      window.MondrianReact.setTheme('contrast')
      localStorage.setItem('mcm_high-contrast', 1)
      setContrastEnabled(true)
    } else {
      window.MondrianReact.setTheme('claro')
      localStorage.removeItem('mcm_high-contrast')
      setContrastEnabled(false)
    }
  }

  const toggleHandTalk = () => {

    const script = document.querySelector('script[id="˜handTalkScript"]');

    if (!script.src) {
      setLoadingHandTalk(true);

      script.src = "https://plugin.handtalk.me/web/latest/handtalk.min.js";
      script.async = true;
      script.crossOrigin = true;

      setTimeout(() => {

        if (window.screen.width >= 768) {
          // Talvez precise tratar algo assincrono aqui
          new window.HT({
            token: "7980f66fc04e8a51e244928880939142",
            avatar: "MAYA",
            mobileConfig: { customButtonStyle: { bottomMargin: '200px' } },
            parentElement: document.querySelector('#root'),
            align: "top"
          });
        }
        setLoadingHandTalk(false);
      }, 1000)
    }
  }

  const onKeyEsc = () => {
    setIsOpenModal(false)
  }

  const toggleAccessibilityBar = () => {
    DOMHeader.current.classList.toggle('mdn-Menu-top--hidden')
  }

  const handleKeyDown = (e) => {
    const actionKeys = {
      65: () => toggleAccessibilityBar(), // 'Shift + A' - Visibilidade da barra acessível
      67: () => scrollToElement(document.querySelector('main.mcm-PageContainer')), // 'Shift + C' - Ir para conteúdo
      70: () => scrollToElement(document.querySelector('footer.mdn-Footer')), // 'Shift + F' - Ir para footer
      84: () => scrollToTop(), // 'Shift + T' - Ir para Topo
      27: () => onKeyEsc(), //'Esc' - Fechar modal
      default: () => null
    }

    return (actionKeys[e.keyCode] || actionKeys.default)()
  }

  return (
    <div className="mdn-Menu-top" ref={DOMHeader}>
      <div className="mdn-Container">
        <nav id="topo" className="mdn-Menu-top-content">
          <ul className="mdn-Menu-top-list mdn-Menu-top-list-left">
            <li className="mdn-Menu-top-list-item mdn-Menu-top-list-item-underline">
              <div
                className="mcm-Menu-top-navigation"
              >
                <span className="mdn-Text">Ir para</span>
                <a href="#content" onClick={() => reportGA4({customTitle: 'header:conteudo'})} className="mdn-Menu-top-action mdn-Text">Conteúdo</a>
              </div>
            </li>
            <li className="mdn-Menu-top-list-item mdn-Menu-top-list-item-underline">
              <div
                className="mcm-Menu-top-navigation"
              >
                <span className="mdn-Text">Ir para</span>
                <a href="#footer" onClick={() => reportGA4({customTitle: 'header:rodape'})} className="mdn-Menu-top-action mdn-Text">Rodapé</a>
              </div>
            </li>
          </ul>
          <ul className="mdn-Menu-top-list mdn-Menu-top-list-right">
            <li className="mdn-Menu-top-list-item mdn-Menu-top-list-item-underline">
              <a
                href="https://www.claro.com.br/institucional/regulatorio/acessibilidade"
                target="_self"
                title="Conheça os recursos da Claro para Acessibilidade"
                className="mdn-Text mdn-Menu-top-action"
                onClick={() => reportGA4({customTitle: 'header:acessibilidade'})}
              >
                <i className="mdn-Icon mdn-Icon-pcd mdn-Icon--sm mdn-Icon--sm" aria-hidden="true"></i>
                <span className="cms-Menu-top-text">Acessibilidade</span>
              </a>
            </li>
            <li className="mdn-Menu-top-list-item mdn-Menu-top-list-item-underline">
              <button
                id="altoContraste"
                type="button"
                className="mdn-Text mdn-Menu-top-action"
                aria-label="Contraste"
                onClick={() => {
                  toggleContrast()
                  reportGA4({customTitle: 'header:contraste'})
                }}
              >
                <i className="mdn-Icon mdn-Icon-alto-contraste mdn-Icon--sm" aria-hidden="true"></i>
                <span className="cms-Menu-top-text">Contraste</span>
              </button>
            </li>
            <li className="mdn-Menu-top-list-item mdn-Menu-top-list-item-underline">
              {loadingHandTalk ?
                <div>
                  <Spinner className="mdn-Spinner" inverse={true} isLoading={loadingHandTalk}/>
                </div>
                :
                <button
                  id="handTalk"
                  type="button"
                  className="mdn-Text mdn-Menu-top-action"
                  aria-label="Hand Talk"
                  onClick={() => {
                    toggleHandTalk()
                    reportGA4({customTitle: 'header:assistente_de_libras'})
                  }}
                >
                <i className="mdn-Icon mdn-Icon-libras mdn-Icon--sm" aria-hidden="true"></i>
                <span className="cms-Menu-top-text"></span>
              </button>}
            </li>
            <li className="mdn-Menu-top-list-item mdn-Menu-top-list-item-underline">
              <button
                id="actionZoom"
                type="button"
                className="mdn-Text mdn-Menu-top-action"
                aria-label="A mais e A menos para dar foco ou diminuir o foco"
                onClick={() => {
                  setIsOpenModal(!isOpenModal)
                  reportGA4({customTitle: 'header:zoom_texto'})
                }}
              >
                <i className="cms-Menu-top-text mdn-Icon-diminuir-tamanho mdn-Icon--sm" aria-hidden="true"></i>
                <i className="cms-Menu-top-text mdn-Icon-aumentar-tamanho mdn-Icon--sm" aria-hidden="true"></i>
              </button>
            </li>
          </ul>
        </nav>
      </div>

      <FontSizeModal
        isOpen={isOpenModal}
        onCloseClick={setIsOpenModal}
      />
    </div>
  )
}

export default AccessibilityBar
